<template>
  <v-container justify-center>
    <v-row>
      <!-- グループジョブ情報表示 -->
      <v-col cols="8">
        <v-card class="mx-auto " max-width="900" min-height="735">   
          <v-img :src="this['job/groupJob'].imagePath" class="white--text align-end text-left" 
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="200px" row>
            <v-card-title  v-text="this['job/groupJob'].jobName" ></v-card-title>
          </v-img>  
          <v-card-text>
            <v-list dense>
              <v-list-item>
                <v-col cols="3">
                  <v-list-item-content class="align-start font-weight-bold">グループ名</v-list-item-content>
                </v-col>
                <v-list-item-content class="align-start">
                  <router-link style="text-decoration: none;" :to="dispGroupDetailLink()">
                    {{ groupByJobId.groupName }}
                  </router-link>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-col cols="3">
                  <v-list-item-content class="align-start font-weight-bold">ジョブ名</v-list-item-content>
                </v-col>
                <v-list-item-content class="align-start">{{ this['job/groupJob'].jobName }}</v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-col cols="3">
                  <v-list-item-content class="align-start font-weight-bold">概要</v-list-item-content>
                </v-col>
                <v-list-item-content class="align-start">{{ this['job/groupJob'].jobOverview }}</v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-col cols="3">
                  <v-list-item-content class="align-start font-weight-bold">カテゴリー</v-list-item-content>
                </v-col>
                <v-chip v-for="category in this['job/groupJob'].categoryList" :key="category.id" color="accent" class="ml-1" small outlined>
                 {{ category.name }}
                </v-chip>
              </v-list-item>

              <v-list-item>
                <v-col cols="3">
                  <v-list-item-content class="align-start font-weight-bold">合計回数</v-list-item-content>
                </v-col>
                <v-list-item-content class="align-start">{{ totalCount }}</v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-col cols="3">
                  <v-list-item-content class="align-start font-weight-bold">目標合計回数</v-list-item-content>
                </v-col>
                <v-list-item-content class="align-start">{{ this['job/groupJob'].jobTargetTotalCount }}</v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-col cols="3">
                  <v-list-item-content class="align-start font-weight-bold">開始日</v-list-item-content>
                </v-col>
                <v-list-item-content class="align-start">{{ this['job/groupJob'].startDate }}</v-list-item-content>
              </v-list-item>
              
              <v-list-item>
                <v-col cols="3">
                  <v-list-item-content class="align-start font-weight-bold">終了日</v-list-item-content>
                </v-col>
                <v-list-item-content class="align-start">{{ this['job/groupJob'].finishDate }}</v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-col cols="3">
                  <v-list-item-content class="align-start font-weight-bold">ステータス</v-list-item-content>
                </v-col>
                <v-list-item-content class="align-start">{{ dispJobStatus }}</v-list-item-content>
              </v-list-item>

            </v-list>
          </v-card-text>
          <div v-show="isJoinGroup" class="text-right">
            <v-btn v-show="!isJoinGroupJob" @click="join" color="primary" class="mr-3 mb-3">このグループジョブに参加する</v-btn>
            <v-btn v-show="isJoinGroupJob" @click="leave" color="secondary" class="mr-3 mb-3">このグループジョブから抜ける</v-btn>
          </div>
        </v-card>
      </v-col>
      <!-- 実施回数表示 -->
      <v-col cols="4">
        <v-card>
          <v-card-title>
            メンバー
            <v-spacer/>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="this['job/groupJobMember']" class="elevation-1" :search="search">
            <template v-slot:[`item.userName`]="{ item }">
              <router-link style="text-decoration: none;" :to="dispJobDetailLink(item)">
                {{ item.userName }}
              </router-link>
            </template>
            <template v-slot:[`item.jobContinueCount`]="{ item }">
              <v-chip :color="getColor(item.jobContinueCount)" dark>{{ item.jobContinueCount }}</v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
      <v-flex xs12 mt-5 justify-center>
        <group-job-evaluation-chart-component />
      </v-flex>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import GroupJobEvaluationChartComponent from '../components/GroupJobEvaluationChart.vue';

export default {
  components: {
    GroupJobEvaluationChartComponent
  },
  created(){
    const jobId = this.$route.params.job_id
    if(!jobId) return
    this.getGroupByJobId(jobId)
    this['job/fetchTheGroupJob'](jobId);
    this['job/fetchGroupJobMember'](jobId);
  },
  data () {
    return {
      search: '',
      headers: [
        {text: 'ユーザー名', align: 'start', sortable: false, value: 'userName'},
        {text: '実績', align: 'start', value: 'jobContinueCount'},
      ],
    }
  },
  computed: {
    ...mapGetters(['loginUserId', 'myGroups','groupByJobId', 'job/groupJob', 'job/groupJobMember']),
    dispJobStatus(){
      switch(Number(this['job/groupJob'].jobStatus)){
        case 1:
          return '継続中'
        case 2:
          return '達成'
        case 9:
          return '削除'
        default:
          return '読み込みできません'
      }
    },
    // グループへの参加状況を判定する
    isJoinGroup(){
      const groupId = this['job/groupJob'].groupId
      return this['myGroups'].some(myGroup => myGroup.groupId === groupId);
    },
    // グループジョブへの参加状況を判定する
    isJoinGroupJob(){
      const userId = this.loginUserId;
      return this['job/groupJobMember'].some(member => member.userId === userId);
    },
    // グループジョブ参加者の合計実施回数を算出する
    totalCount(){
      let totalCount = 0
      this['job/groupJobMember'].forEach(member => totalCount += member.jobContinueCount)
      return totalCount
    },
  },
  methods: {
    getColor(jobContinueCount) {
      const target = this['job/groupJob'].jobTargetTotalCount
      if (jobContinueCount > target / 2) return 'green'
      else if (jobContinueCount > target / 4) return 'orange'
      else return 'red'
    },
    join(){
      if(confirm(`グループジョブ「${this['job/groupJob'].jobName}」に参加しますか？`)){
        this['job/joinGroupJob'](this['job/groupJob']);
      }
    },
    leave(){
      const groupJob = this['job/groupJob'];
      const groupJobMember = this['job/groupJobMember'];
      if(confirm(`グループジョブ「${groupJob.jobName}」から抜けますか？`)){
        if(groupJobMember.length == 1){
          if(confirm('あなたが最後のメンバーです。このジョブを削除しますか？')){
            this['job/deleteGroupJob'](groupJob);
            this['job/leaveGroupJob'](groupJob);
            this.$router.push({ name: 'JobIndex' })
          } else{
            return;
          }
        }
        this['job/leaveGroupJob'](groupJob);
        this.$router.push({ name: 'JobIndex' })
      }
    },
    dispJobDetailLink(member){
      const userId = member.userId;
      return userId === this.loginUserId ? {name: 'User'} 
                                         : { name: 'User', params: { 'user_id': userId }}
    },
    dispGroupDetailLink(){
      return this.groupByJobId.groupId ? {name: 'GroupDetail', params: {'group_id': this.groupByJobId.groupId}}
                                       : {name: 'GroupDetail', params: {'group_id': 'null'}}
    },
    ...mapActions(['getGroupByJobId', 'job/fetchTheGroupJob', 'job/fetchGroupJobMember', 'job/joinGroupJob', 'job/leaveGroupJob', 'job/deleteGroupJob'])
  }
}
</script>
